import { Routes } from '@angular/router';
import { LoginComponent } from './modules/login/login.component';
import { HomeComponent } from './modules/home/home.component';
import { AuthorizationGuard } from './guards/authorization.guard';
import { LoginGuard } from './guards/login.guard';
import { PlansComponent } from './modules/plans/plans.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { CustomersComponent } from './modules/customers/customers.component';
import { CustomerPlansComponent } from './modules/customer-plans/customer-plans/customer-plans.component';
import { DevicesComponent } from './modules/devices/devices.component';
import { PartnersComponent } from './modules/partners/partners.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { UserManagementComponent } from './modules/user-management/user-management.component';
import { PlanDevicesComponent } from './modules/plan-devices/plan-devices/plan-devices.component';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { CreatePasswordComponent } from './modules/create-password/create-password.component';
import { SecurityVerificationComponent } from './modules/security-verification/security-verification.component';
import { PartnerCustomersComponent } from './modules/partner-customers/partner-customers/partner-customers.component';
import { VerificationCodeGuard } from './guards/verification-code.guard';
import { ValidateNewPasswordComponent } from './modules/validate-new-password/validate-new-password.component';
import { VerifyNewPasswordGuard } from './guards/verify-new-password.guard';
import { CreateNewPasswordGuard } from './guards/create-new-password.guard';
import { ViewPlansComponent } from './modules/plans/view-plans/view-plans.component';
import { ViewCustomerComponent } from './modules/customers/view-customer/view-customer.component';
import { ViewPartnerComponent } from './modules/partners/view-partner/view-partner.component';
import { ViewUsersComponent } from './modules/user-management/view-users/view-users.component';
import { CreateUserComponent } from './modules/user-management/create-user/create-user.component';
import { UpdateUserManagementComponent } from './modules/user-management/update-user-management/update-user-management.component';
import { RoleManagementComponent } from './modules/role-management/role-management.component';
import { CreateRoleComponent } from './modules/role-management/create-role/create-role.component';
import { UpdateRoleComponent } from './modules/role-management/update-role/update-role.component';
import { ViewRoleComponent } from './modules/role-management/view-role/view-role.component';
import { CustomerUsersComponent } from './modules/customer-users/customer-users/customer-users.component';
import { UserUpdateComponent } from './modules/customer-users/user-update/user-update.component';
import { NotificationsComponent } from './modules/notifications/notifications.component';
import { PartnerStaffComponent } from './modules/partner-staff/partner-staff/partner-staff.component';
import { UpdatePartnerStaffComponent } from './modules/partner-staff/update-partner-staff/update-partner-staff.component';
import { InventoryComponent } from './modules/inventory/inventory/inventory.component';
import { InventoryUpdateComponent } from './modules/inventory/inventory-update/inventory-update.component';
import { SendSMSComponent } from './modules/send-sms/send-sms.component';
import { InventoryDeviceTransfersComponent } from './modules/inventory/inventory-device-transfers/inventory-device-transfers.component';
import { InventoryListComponent } from './modules/inventory/inventory-list/inventory-list.component';
import { TicketsListComponent } from './modules/tickets/tickets-list/tickets-list.component';
import { TicketsComponent } from './modules/tickets/tickets.component';
import { TicketUpdateComponent } from './modules/tickets/ticket-update/ticket-update.component';
import { TicketViewComponent } from './modules/tickets/ticket-view/ticket-view.component';
import { CustomerDeviceActivationComponent } from './modules/customers/customer-device-activation/customer-device-activation.component';
import { ListCustomersComponent } from './modules/customers/list-customers/list-customers.component';

import { ListPartnersComponent } from './modules/partners/list-partners/list-partners.component';
import { PartnerDeviceActivationComponent } from './modules/partners/partner-device-activation/partner-device-activation.component';
import { DistributorsComponent } from './modules/distributors/distributors.component';
import { ListDistributorsComponent } from './modules/distributors/list-distributors/list-distributors.component';
import { CreateDistributorsComponent } from './modules/distributors/create-distributors/create-distributors.component';
import { ViewDistributorComponent } from './modules/distributors/view-distributor/view-distributor.component';
import { DistributorAccountComponent } from './modules/distributors/distributor-account/distributor-account.component';
import { DistributorStaffComponent } from './modules/distributors/distributor-staff/distributor-staff/distributor-staff.component';
import { UpdateDistributorStaffComponent } from './modules/distributors/distributor-staff/update-distributor-staff/update-distributor-staff.component';
import { CustomerDeviceUpdateComponent } from './modules/customers/customer-device-update/customer-device-update.component';
import { InventoryDeviceRevertTransferComponent } from './modules/inventory/inventory-device-revert-transfer/inventory-device-revert-transfer.component';
import { SecurityVerificationOptionsComponent } from './modules/security-verification-options/security-verification-options.component';
import { CustomerPlanDevicesComponent } from './modules/customers/view-customer/customer-plan-devices/customer-plan-devices.component';
import { PlanTypesComponent } from './modules/settings/plan-types/plan-types.component';
import { PlanTypeFormComponent } from './modules/settings/plan-types/plan-type-form/plan-type-form.component';
import { SettingsComponent } from './modules/settings/settings.component';
import { CustomerPlanDeviceUpdateComponent } from './modules/customers/view-customer/customer-plan-devices/customer-plan-device-update/customer-plan-device-update.component';
import { ThresholdComponent } from './modules/settings/threshold/threshold.component';
import { CarrierApiSettingsComponent } from './modules/settings/carrier-api-settings/carrier-api-settings.component';
import { SimSearchComponent } from './modules/simSearch/simSearch.component';
import { CustomerAccountComponent } from './modules/customers/customer-account/customer-account.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  {
    path: 'create-password',
    component: CreatePasswordComponent,
    canActivate: [CreateNewPasswordGuard],
  },
  {
    path: 'security-verification',
    component: SecurityVerificationComponent,
    canActivate: [VerificationCodeGuard],
  },
   {
    path: 'security-verification-options',
    component: SecurityVerificationOptionsComponent,
    canActivate: [VerificationCodeGuard],
  },
  {
    path: 'verify-new-password',
    component: ValidateNewPasswordComponent,
    canActivate: [VerifyNewPasswordGuard],
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '',
    component: SidebarComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 1,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
      },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 2,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
      },
      {
        path: 'plans',
        component: PlansComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 3,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
      },
      {
        path: 'view-plans/:id',
        component: ViewPlansComponent,
        canActivate: [AuthorizationGuard],
        data: { functionality: 3, requiredAccessLevel: [PERMISSION.Read] },
      },

      {
        path: 'customers',
        component: CustomersComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: MODULE_ID.Customers,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
        children: [
          {
            path: '',
            component: ListCustomersComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'customer-plans',
            component: CustomerPlansComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Edit] },
          },
          {
            path: 'customer-account/:id',
            component: CustomerAccountComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'view-customer/:id',
            component: ViewCustomerComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Read] },
          },
           {
            path: 'view-customer/:id/:userPlanId',
            component: CustomerPlanDevicesComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'view-customer/:id/:userPlanId/:iccid',
            component: CustomerPlanDeviceUpdateComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'customer-users/:id',
            component: CustomerUsersComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'user-update',
            component: UserUpdateComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'plan-devices',
            component: PlanDevicesComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Edit] },
          },
          {
            path: 'device-activation/:id',
            component: CustomerDeviceActivationComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Read] },
          },
           {
            path: 'device/update/:id',
            component: CustomerDeviceUpdateComponent,
            data: { functionality: MODULE_ID.Customers, requiredAccessLevel: [PERMISSION.Read] },
          },
          
        ],
      },

      {
        path: 'devices',
        component: DevicesComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 5,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
      },
      {
        path: 'partners',
        component: PartnersComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 6,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
        children: [
          {
            path: '',
            component: ListPartnersComponent,
            data: { functionality: 6, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'view-partner/:id',
            component: ViewPartnerComponent,
            data: { functionality: 6, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'partner-customers',
            component: PartnerCustomersComponent,
            data: {
              functionality: 6,
              requiredAccessLevel: [PERMISSION.Edit],
            },
          },
          {
            path: 'partner-staff',
            component: PartnerStaffComponent,
            data: { functionality: 6, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'update-partner-staff',
            component: UpdatePartnerStaffComponent,
            data: { functionality: 4, requiredAccessLevel: [PERMISSION.Read] },
          },
           {
            path: 'device-activation/:id',
            component: PartnerDeviceActivationComponent,
            data: { functionality: 6, requiredAccessLevel: [PERMISSION.Read] },
          },
        ],
      },
      {
        path: 'distributors',
        component: DistributorsComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 14,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
        children: [
          {
            path: '',
            component: ListDistributorsComponent,
            data: { functionality: 14, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'view-distributor/:id',
            component: ViewDistributorComponent,
            data: { functionality: 14, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'distributor-account',
            component: DistributorAccountComponent,
            data: { functionality: 14, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'distributor-account/:id',
            component: DistributorAccountComponent,
            data: { functionality: 14, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'distributor-staff',
            component: DistributorStaffComponent,
            data: { functionality: 14, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'update-distributor-staff',
            component: UpdateDistributorStaffComponent,
            data: { functionality: 14, requiredAccessLevel: [PERMISSION.Read] },
          },
        ],
      },
      {
        path: 'user-management',
        component: UserManagementComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 7,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
        children: [
          {
            path: 'view-users/:id',
            component: ViewUsersComponent,
            data: { functionality: 7, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'create-user',
            component: CreateUserComponent,
            data: {
              functionality: 7,
              requiredAccessLevel: [PERMISSION.Create],
            },
          },
          {
            path: 'update-user-management/:id',
            component: UpdateUserManagementComponent,
            data: {
              functionality: 7,
              requiredAccessLevel: [PERMISSION.Edit],
            },
          },
        ],
      },
      {
        path: 'role-management',
        component: RoleManagementComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 8,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
        children: [
          {
            path: 'create-role',
            component: CreateRoleComponent,
            data: {
              functionality: 8,
              requiredAccessLevel: [PERMISSION.Create],
            },
          },
          {
            path: 'update-role/:id',
            component: UpdateRoleComponent,
            data: {
              functionality: 8,
              requiredAccessLevel: [PERMISSION.Edit],
            },
          },
          {
            path: 'view-role/:id',
            component: ViewRoleComponent,
            data: {
              functionality: 8,
              requiredAccessLevel: [PERMISSION.Read],
            },
          }
        ],
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 9,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
      },
      {
        path: 'inventory',
        component: InventoryComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 10,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
        children: [

          {
            path: '',
            component: InventoryListComponent,
            data: { functionality: 10, requiredAccessLevel: [PERMISSION.Edit] },
          },
          {
            path: 'inventory-update/:id',
            component: InventoryUpdateComponent,
            data: { functionality: 10, requiredAccessLevel: [PERMISSION.Edit] },
          },
          {
            path: 'transfers',
            component: InventoryDeviceTransfersComponent,
            data: { functionality: 10, requiredAccessLevel: [PERMISSION.Edit] },
          },
           {
            path: 'revert-transfer',
            component: InventoryDeviceRevertTransferComponent,
            data: { functionality: 10, requiredAccessLevel: [PERMISSION.Edit] },
          },
        ],
      },
      {
        path: 'sendSms',
        component: SendSMSComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 11,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },

      },
       {
        path: 'tickets',
        component: TicketsComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 12,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
        children: [

          {
            path: '',
            component: TicketsListComponent,
            data: { functionality: 12, requiredAccessLevel: [PERMISSION.Edit] },
          },
          {
            path: 'view/:id',
            component: TicketViewComponent,
            data: { functionality: 12, requiredAccessLevel: [PERMISSION.Edit] },
          },
           {
            path: 'update/:id',
            component: TicketUpdateComponent,
            data: { functionality: 12, requiredAccessLevel: [PERMISSION.Edit] },
          },
         
        ],
      },

      {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [AuthorizationGuard],
        data: {
          functionality: 13,
          requiredAccessLevel: [
            PERMISSION.Read,
            PERMISSION.Edit,
            PERMISSION.Archive,
            PERMISSION.Create,
          ],
        },
        children: [

          {
            path: '',
            component: SettingsComponent,
            data: { functionality: 13, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'plan-types',
            component: PlanTypesComponent,
            data: { functionality: 13, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'plan-types/create',
            component: PlanTypeFormComponent,
            data: { functionality: 13, requiredAccessLevel: [PERMISSION.Read] },
          },
           {
            path: 'plan-types/update/:id',
            component: PlanTypeFormComponent,
            data: { functionality: 13, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'threshold',
            component: ThresholdComponent,
            data: { functionality: 13, requiredAccessLevel: [PERMISSION.Read] },
          },
          {
            path: 'carrier-api-settings',
            component: CarrierApiSettingsComponent,
            data: { functionality: 13, requiredAccessLevel: [PERMISSION.Read] },
          },
        ],
      },

      {
        path: 'simSearch',
        component: SimSearchComponent,
        canActivate: [AuthorizationGuard],
        data: { functionality: 4, requiredAccessLevel: [PERMISSION.Read] },
      },
      {
        path: 'simSearch/:customerId',
        component: SimSearchComponent,
        canActivate: [AuthorizationGuard],
        data: { functionality: 4, requiredAccessLevel: [PERMISSION.Read] },
      },
    ],
  },




  { path: '**', redirectTo: '/login' },
];

